import { memo } from 'react';
import styles from './Advt.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import { AnimatePresence, motion } from 'motion/react';

const Advt = memo(() => {
  const { title, qrCode1, qrCode2, paddingQR, sizeQR, titleFontSize } =
    useGetParams();

  return (
    <div className={styles.wrapper}>
      {title && (
        <motion.div
          initial={{ opacity: 0, y: '100vh' }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ opacity: { duration: 0.5 }, y: { duration: 0.63 } }}
          exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
          className={styles.title}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          <div className={styles.wiggle}>{title}</div>
        </motion.div>
      )}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              opacity: { duration: 0.8, delay: 0.25 },
              scale: { duration: 1.4, delay: 0.25 },
            }}
            className={styles.qrCode}
            exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              opacity: { duration: 0.8, delay: 0.25 },
              scale: { duration: 1.4, delay: 0.25 },
            }}
            exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode2" />
          </motion.div>
        )}
      </div>
    </div>
  );
});

export default Advt;
